export default {"src":"/_next/static/media/sports.ce58692b.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};